var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"90f93a9cb6dc4608cc401773724667fcbb92a1dd"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["elo-cabinets@ablefy"]={id:"90f93a9cb6dc4608cc401773724667fcbb92a1dd"};
      